<style lang="less" scoped>
.el-container {height: 100vh;padding: 0px; background: #0A2E5D;}
.el-header {padding: 0px;}
.el-main {padding: 0px;display: flex;}
.top {z-index: 400;margin: 0 auto;padding-bottom: 0;}
.right {z-index: 400;margin: 0 auto;}
.center {height: 100%;display: flex;flex-direction: column;justify-content: center;}
.left {z-index: 400;margin: 0 auto;}
.myMenu, ul, li {background-color: transparent !important;}
li {cursor: pointer;/* 取消多次点击文本被选中 */user-select: none;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;}
.myMenu/deep/.is-active {border-bottom: none;}
.map {width: 8rem !important;height: 7.5rem !important;border: 1px solid #68d8fe;margin-top: .2rem;border-radius: .05rem;}
.navigation {width: 8rem;z-index: 500;margin: 0.1rem auto;font-size: 14px;pointer-events: none;}
.myMenu {width: 100%;height: 100%;}
.el-menu.el-menu--horizontal {border-bottom: none;height: 100%;width: 100%;opacity: 0.8;display: flex;flex-direction: row;justify-content: center;}
/deep/.el-menu-item {width: 5.5rem;;height: 100%;font-size: 12px;font-weight: bold;text-align: center;padding: 0; display: flex;flex-direction:column; justify-content:center;border-bottom: none;text-decoration: none;}
.myitem > span {text-align: center;color: #FFF;line-height: .2rem;}
.myitem > img {text-align: center;width: .5rem;height: .325rem;display: inline-block;margin: 0px auto}
.title {width: 100%;font-size: 14px;font-weight: bold;color: #ffffff;text-align: center;margin: 0;}
.containerbox {display: flex;flex-direction: column;justify-content: center;height: 100%!important;}
.echartsbox {width: 4.5rem;height: 90%;}
.kyxm-data {width: 100%;height: 33.33%;}
.container {background-image: url('/static/images/szdp/image_frame2.png');background-size: 100% 100%;background-repeat: no-repeat;width: 5rem;height: 33.33%;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: center;align-content: flex-end;}
/deep/.el-col {height: 100%;}
ul{list-style: none;padding: 0;margin: 0;color: #FFF;}
::-webkit-scrollbar {
  display: none;
}
</style>

<template>
  <el-container>
    <ScaleBox>
      <el-header><Top class="top" /></el-header>
      <el-main>
        <div class="left containerbox">
          <div class="container">
            <h1 class="title">东盟国家矿床点数量</h1>
            <div id="point" class="echartsbox"></div>
          </div>
          <div class="container">
            <h1 class="title">东盟国家矿产资源量全球占比</h1>
            <div id="ring" class="echartsbox"></div>
          </div>
          <div class="container">
            <h1 class="title">平台资料库数据</h1>
            <div id="round" class="echartsbox"></div>
          </div>
        </div>
        <div class="center">
          <Map class="map"></Map>
          <div class="navigation">
            <div class="myMenu">
              <el-menu :default-active="activeIndex" class="menu" mode="horizontal">
                <el-menu-item class="myitem" v-for="(e, i) in menu" :key="i" :index="e.module" :data-id="e.index">
                  <img :src="e.src" class="menuimg" />
                  <span>{{e.name}}</span>
                  <span>{{e.namee}}</span>
                </el-menu-item>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="right containerbox">
          <Kyxm class="kyxm-data" :kyxmData = kyxmData></Kyxm>
          <div class="container">
            <h1 class="title">柬埔寨矿业权分类信息</h1>
            <div id="InCambodia" class="echartsbox"></div>
          </div>
          <div class="container">
            <h1 class="title">老挝矿业权分类信息</h1>
            <div id="Laos" class="echartsbox"></div>
          </div>
        </div>
      </el-main>
    </ScaleBox>
  </el-container>
</template>

<script>
import filters from '../../method/filter'
import Map from './Map.vue'
import Top from './Top.vue'
import Kyxm from './Kyxm.vue'
import ScaleBox from '../../assembly/ScaleBox.vue'
export default {
  components: {
    Kyxm,
    Top,
    Map,
    ScaleBox
  },
  mixins: [filters],
  data()
  {
    return {
      activeIndex: '0',
      menu: [
        {
          index: '0',
          name: '东盟',
          namee: 'ASEAN',
          module: 'ASEAN',
          src: ('static/images/szdp/image_ASEAN.png')
        },
        {
          index: '1',
          name: '柬埔寨',
          namee: 'Cambodia',
          module: 'Cambodia',
          src: ('static/images/szdp/image_Cambodia.png')
        },
        {
          index: '2',
          name: '老挝',
          namee: 'Laos',
          module: 'Laos',
          src: ('static/images/szdp/image_Laos.png')
        },
        {
          index: '3',
          name: '马来西亚',
          namee: 'Malaysia',
          module: 'Malaysia',
          src: ('static/images/szdp/image_Malaysia.png')
        },
        {
          index: '4',
          name: '缅甸',
          namee: 'Myanmar',
          module: 'Myanmar',
          src: ('static/images/szdp/image_Myanmar.png')
        },
        {
          index: '5',
          name: '泰国',
          namee: 'Thailand',
          module: 'Thailand',
          src: ('static/images/szdp/image_Thailand.png')
        },
        {
          index: '6',
          name: '文莱',
          namee: 'Brunei',
          module: 'Brunei',
          src: ('static/images/szdp/image_Brunei.png')
        },
        {
          index: '7',
          name: '新加坡',
          namee: 'Singapore',
          module: 'Singapore',
          src: ('static/images/szdp/image_Singapore.png')
        },
        {
          index: '8',
          name: '印度尼西亚',
          namee: 'Indonesia',
          module: 'Indonesia',
          src: ('static/images/szdp/image_Indonesia.png')
        },
        {
          index: '9',
          name: '越南',
          namee: 'Vietnam',
          module: 'Vietnam',
          src: ('static/images/szdp/image_Vietnam.png')
        },
        {
          index: '10',
          name: '菲律宾',
          namee: 'Philippines',
          module: 'Philippines',
          src: ('static/images/szdp/image_Philippines.png')
        }
      ],
      kyxmData: []
    }
  },
  created()
  {
    this.$nextTick(() =>
    {
      this.drawLine()
      this.drawLine2()
      this.drawLine3()
      this.drawLine5()
      this.drawLine6()
      this.getKyxm()
    })
  },
  methods: {
    drawLine()
    {
      let analysis = this.$echarts.init(document.getElementById('point'))
      let color1 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#09AADE'
          },
          {
            offset: 1,
            color: '#35D0E9'
          }
        ]
      }
      let color2 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#0C3FFD'
          },
          {
            offset: 1,
            color: '#3764FC'
          }
        ]
      }
      let color3 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#5C3CC1'
          },
          {
            offset: 1,
            color: '#9167FC'
          }
        ]
      }
      let color4 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#F78861'
          },
          {
            offset: 1,
            color: '#E4D682'
          }
        ]
      }
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function(params)
          {
            const item = params[0]
            return item.name + ' : ' + item.value
          }
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {
              backgroundColor: '#031245'
            },
            restore: {}
          },
          iconStyle: {
            borderColor: '#c0c3cd'
          }
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 20,
          bottom: 10,
          top: 10
        },
        xAxis: {
          show: true,
          data: [
            '铬',
            '钾盐',
            '金',
            '铝',
            '煤',
            '锰',
            '镍',
            '铅',
            '钛',
            '锑',
            '铁',
            '铜',
            '钨',
            '锡',
            '锌'
          ],
          axisLabel: {
            show: true,
            color: '#FFF',
            fontSize: 12,
            interval: 0
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#384267',
              width: 1
            }
          },
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#384267',
              type: 'dashed'
            }
          },
          type: 'category'
        },
        yAxis: {
          min: 0,
          max: 1200,
          interval: 300,
          nameTextStyle: {
            color: '#FFF',
            padding: [0, 0, -10, 0],
            fontSize: 12
          },
          // 字体样式
          axisLabel: {
            fontSize: 12,
            color: '#FFF'
          },
          axisTick: {
            lineStyle: {
              color: '#384267',
              width: 1
            },
            show: true
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#384267',
              type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#384267',
              width: 1,
              type: 'dashed'
            },
            show: true
          }
        },
        series: [
          {
            // 实体部分
            data: [
              290, 420, 560, 300, 150, 150, 290, 300, 50, 150, 300, 600, 150,
              600, 20
            ],
            type: 'bar',
            barMaxWidth: 'auto',
            barWidth: 10,
            itemStyle: {
              normal: {
                color: function(params)
                {
                  //自定义颜色
                  let colorList = [color1, color2, color3, color4, color1, color2, color3, color4, color1, color2, color3, color4, color1, color2, color3]
                  return colorList[params.dataIndex]
                }
              }
            },
            label: {
              show: true,
              position: 'top',
              distance: 10,
              fontSize: 12,
              color: '#FFFFFF'
            }
          },
          {
            // 底面
            data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
            type: 'pictorialBar',
            barMaxWidth: '10',
            symbol: 'diamond',
            symbolOffset: [0, '50%'],
            symbolSize: [10, 10],
            itemStyle: {
              normal: {
                color: function(params)
                {
                  //自定义颜色
                  let colorList = ['#35D0E9', '#3764FC', '#9167FC', '#E4D682', '#35D0E9', '#3764FC', '#9167FC', '#E4D682', '#35D0E9', '#3764FC', '#9167FC', '#E4D682', '#35D0E9', '#3764FC', '#9167FC']
                  return colorList[params.dataIndex]
                }
              }
            }
          },
          {
            // 实体顶面
            data: [
              290, 290, 560, 300, 150, 150, 290, 300, 50, 150, 300, 600, 150,
              600, 20
            ],
            type: 'pictorialBar',
            barMaxWidth: '10',
            symbolPosition: 'end',
            symbol: 'diamond',
            symbolOffset: [0, '-50%'],
            symbolSize: [10, 10],
            zlevel: 2,
            itemStyle: {
              normal: {
                color: function(params)
                {
                  //自定义颜色
                  let colorList = [color1, color2, color3, color4, color1, color2, color3, color4, color1, color2, color3, color4, color1, color2, color3]
                  return colorList[params.dataIndex]
                }
              }
            }
          },
          {
            // 空心部分
            data: [
              1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
              1200, 1200, 1200, 1200
            ],
            type: 'bar',
            barMaxWidth: 'auto',
            barWidth: 10,
            barGap: '-100%',
            zlevel: -1,
            itemStyle: {
              normal: {
                color: function(params)
                {
                  //自定义颜色
                  let colorList = ['#00FFF6', '#3764FC', '#9167FC', '#E4D682', '#00FFF6', '#3764FC', '#9167FC', '#E4D682', '#00FFF6', '#3764FC', '#9167FC', '#E4D682', '#00FFF6', '#3764FC', '#9167FC']
                  return colorList[params.dataIndex]
                },
                opacity: 0.1
              }
            }
          },
          {
            // 空心顶面
            data: [
              1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200,
              1200, 1200, 1200, 1200
            ],
            type: 'pictorialBar',
            barMaxWidth: '10',
            symbolPosition: 'end',
            symbol: 'diamond',
            symbolOffset: [0, '-50%'],
            symbolSize: [10, 10],
            zlevel: -1,
            itemStyle: {
              normal: {
                color: function(params)
                {
                  //自定义颜色
                  let colorList = ['#00FFF6', '#19CEF8', '#0364C6', '#FFE894', '#00FFF6', '#19CEF8', '#0364C6', '#FFE894', '#00FFF6', '#19CEF8', '#0364C6', '#FFE894', '#00FFF6', '#19CEF8', '#0364C6']
                  return colorList[params.dataIndex]
                },
                opacity: 0.1
              }
            }
          }
        ]
      }
      option && analysis.setOption(option)
    },
    drawLine2()
    {
      let analysis = this.$echarts.init(document.getElementById('ring'))
      let trafficWay = [
        { value: 160, name: '煤' },
        { value: 150, name: '铁' },
        { value: 140, name: '铬' },
        { value: 130, name: '钛' },
        { value: 120, name: '钨' },
        { value: 110, name: '锡' },
        { value: 100, name: '铜' },
        { value: 90, name: '金' },
        { value: 80, name: '铅' },
        { value: 70, name: '锌' },
        { value: 60, name: '银' },
        { value: 50, name: '钴' },
        { value: 40, name: '锑' },
        { value: 30, name: '锰' },
        { value: 20, name: '铝土' },
        { value: 10, name: '钾盐' }
      ]
      let color1 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#09AADE'
          },
          {
            offset: 1,
            color: '#35D0E9'
          }
        ]
      }
      let color2 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#0C3FFD'
          },
          {
            offset: 1,
            color: '#3764FC'
          }
        ]
      }
      let color3 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#5C3CC1'
          },
          {
            offset: 1,
            color: '#9167FC'
          }
        ]
      }
      let color4 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            offset: 0,
            color: '#F78861'
          },
          {
            offset: 1,
            color: '#E4D682'
          }
        ]
      }
      let option = {
        series: [
          {
            name: 'Nightingale Chart',
            type: 'pie',
            radius: document.documentElement.clientWidth > 1560 ? [45, 100] : [25, 60],
            center: ['50%', '50%'],
            roseType: 'area',
            data: trafficWay,
            itemStyle: {
              normal: {
                color: function(params)
                {
                  //自定义颜色
                  let colorList = [
                    color1,
                    color2,
                    color3,
                    color4,
                    color1,
                    color2,
                    color3,
                    color4,
                    color1,
                    color2,
                    color3,
                    color4,
                    color1,
                    color2,
                    color3
                  ]
                  return colorList[params.dataIndex]
                },
                label: {
                  show: true,
                  position: 'outside',
                  color: '#fff',
                  formatter: function(params)
                  {
                    let percent = 0
                    let total = 0
                    for (let i = 0; i < trafficWay.length; i++)
                      total += trafficWay[i].value
                    percent = ((params.value / total) * 100).toFixed(0)
                    if (params.name !== '') return params.name + percent + '%'
                    else return ''
                  }
                },
                labelLine: {
                  length: 10,
                  length2: 10,
                  show: true,
                  color: '#ffffff'
                }
              }
            }
          }
        ]
      }
      option && analysis.setOption(option)
    },
    drawLine3()
    {
      let analysis = this.$echarts.init(document.getElementById('round'))
      let img =
        'data:image/png;base64,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'
      let trafficWay = [
        {name: '地形地质', value: 10},
        {name: '投资环境', value: 10},
        {name: '矿产资源', value: 10},
        {name: '法律法规', value: 10},
        {name: '其他', value: 10}
      ]
      let data = []
      let color = [
        '#00ffff',
        '#00cfff',
        '#006ced',
        '#ffe000',
        '#ffa800',
        '#ff5b00',
        '#ff3000'
      ]
      for (let i = 0; i < trafficWay.length; i++)
      {
        data.push(
          {
            value: trafficWay[i].value,
            name: trafficWay[i].name,
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderColor: color[i],
                shadowColor: color[i]
              }
            }
          },
          {
            value: 2,
            name: '',
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
                color: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 0
              }
            }
          }
        )
      }
      let seriesOption = [
        {
          name: '',
          type: 'pie',
          clockWise: false,
          radius: document.documentElement.clientWidth > 1560 ? [75, 100] : [55, 60],
          hoverAnimation: false,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'outside',
                color: '#FFF',
                formatter: function(params)
                {
                  let percent = 0
                  let total = 0
                  for (let i = 0; i < trafficWay.length; i++)
                    total += trafficWay[i].value
                  percent = ((params.value / total) * 100).toFixed(0)
                  if (params.name !== '')
                  {
                    return (
                      params.name +
                      '\n' +
                      '\n' +
                      '占比：' +
                      percent +
                      '%'
                    )
                  }
                  else return ''
                }
              },
              labelLine: {
                length: 10,
                length2: 10,
                show: true,
                color: '#FFF'
              }
            }
          },
          data: data
        }
      ]
      let option = {
        color: color,
        title: {
          text: '平台资料库',
          top: '45%',
          left: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 16,
            fontWeight: '400'
          }
        },
        graphic: {
          elements: [
            {
              type: 'image',
              z: 3,
              style: {
                image: img,
                width: document.documentElement.clientWidth > 1560 ? 128 : 90,
                height: document.documentElement.clientWidth > 1560 ? 128 : 90
              },
              left: 'center',
              top: 'center',
              position: [100, 100]
            }
          ]
        },
        tooltip: {
          show: false
        },
        toolbox: {
          show: false
        },
        series: seriesOption
      }
      option && analysis.setOption(option)
    },
    drawLine5()
    {
      let analysis = this.$echarts.init(document.getElementById('InCambodia'))
      let option

      let data = [{
        name: '政府完整数据',
        value: 100
      },
      {
        name: '政府部分数据1',
        value: 75
      },
      {
        name: '政府部分数据2',
        value: 50
      },
      {
        name: '政府部分数据3',
        value: 25
      }
      ]
      let arrName = getArrayValue(data, 'name')
      let arrValue = getArrayValue(data, 'value')
      let sumValue = eval(arrValue.join('+'))
      let objData = array2obj(data, 'name')
      let optionData = getData(data)
      function getArrayValue(array, key)
      {
        var res = []
        if (array)
        {
          array.forEach(function(t)
          {
            res.push(t[key])
          })
        }
        return res
      }

      function array2obj(array, key)
      {
        var resObj = {}
        for (var i = 0; i < array.length; i++)
          resObj[array[i][key]] = array[i]
        return resObj
      }

      function getData(data)
      {
        var res = {
          series: [],
          yAxis: []
        }
        for (let i = 0; i < data.length; i++)
        {
          res.series.push({
            name: '',
            type: 'pie',
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [73 - i * 15 + '%', 68 - i * 15 + '%'],
            center: ['30%', '55%'],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [{
              value: data[i].value,
              name: data[i].name
            }, {
              value: sumValue - data[i].value,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
          })
          res.series.push({
            name: '',
            type: 'pie',
            silent: true,
            z: 1,
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [73 - i * 15 + '%', 68 - i * 15 + '%'],
            center: ['30%', '55%'],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [{
              value: 7.5,
              itemStyle: {
                color: 'rgb(3, 31, 62)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }, {
              value: 2.5,
              name: '',
              itemStyle: {
                color: 'rgba(0,0,0,0)',
                borderWidth: 0
              },
              tooltip: {
                show: false
              },
              hoverAnimation: false
            }]
          })
          res.yAxis.push((data[i].value / sumValue * 100).toFixed(2) + '%')
        }
        return res
      }
      option = {
        legend: {
          show: true,
          icon: 'circle',
          top: 'center',
          bottom: '53%',
          left: '50%',
          data: arrName,
          width: 40,
          padding: [0, 16],
          itemGap: 25,
          formatter: function(name)
          {
            return '{title|' + name + '} {value|' + (objData[name].value) + '}  {title|项}'
          },
          textStyle: {
            rich: {
              title: {
                fontSize: 12,
                color: 'rgb(0, 178, 246)'
              },
              value: {
                fontSize: 16,
                color: '#fff'
              }
            }
          }
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b}:{c}({d}%)'
        },
        color: ['rgb(9,187,247)', 'rgb(184,254,165)', 'rgb(253,218,23)', 'rgb(252,152,12)'],
        xAxis: [{
          show: false
        }],
        series: optionData.series
      }
      option && analysis.setOption(option)
    },
    drawLine6()
    {
      let analysis = this.$echarts.init(document.getElementById('Laos'))
      let option
      let category = [
        {name: '采矿权', value: 152},
        {name: '可行性研究区', value: 123},
        {name: '勘探区', value: 88},
        {name: '远景区', value: 29},
        {name: '新增申请矿权区', value: 5},
        {name: '省圈定矿权', value: 32},
        {name: '合作探矿区', value: 79}
      ]
      // 类别
      let total = 200 // 数据总数
      let datas = []
      category.forEach((value) =>
      {
        datas.push(value.value)
      })
      option = {
        xAxis: {
          max: total,
          splitLine: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          left: 120,
          top: 20, // 设置条形图的边距
          right: 40,
          bottom: 20
        },
        yAxis: [
          {
            type: 'category',
            inverse: false,
            data: category,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            }
          }
        ],
        series: [
          {
            // 内
            type: 'bar',
            barWidth: 16,
            barGap: '80%',
            legendHoverLink: false,
            silent: true,
            itemStyle: {
              normal: {
                color: '#06e3f1'
              }
            },
            label: {
              normal: {
                show: true,
                position: 'left',
                formatter: '{b}',
                textStyle: {
                  color: '#fff',
                  fontSize: 10
                }
              }
            },
            data: category,
            z: 1,
            animationEasing: 'elasticOut'
          },
          {
            // 分隔
            type: 'pictorialBar',
            itemStyle: {
              normal: {
                color: '#061348'
              }
            },
            symbolRepeat: 'fixed',
            symbolMargin: 6,
            symbol: 'rect',
            symbolClip: true,
            symbolSize: [1, 21],
            symbolPosition: 'start',
            symbolOffset: [1, -1],
            symbolBoundingData: this.total,
            data: category,
            z: 2,
            animationEasing: 'elasticOut'
          },
          {
            // 外边框
            type: 'pictorialBar',
            symbol: 'rect',
            symbolBoundingData: total,
            itemStyle: {
              normal: {
                color: 'none'
              }
            },
            label: {
              normal: {
                formatter: (params) =>
                {
                  return  '{f|  ' + params.data + '}'
                },
                rich: {
                  a: {
                    color: '#FFF',
                    fontSize: 24
                  },
                  b: {
                    color: '#FFF'
                  },
                  c: {
                    color: '#FFF'
                  },
                  d: {
                    color: '#FFF'
                  },
                  f: {
                    color: '#FFF'
                  }
                },
                position: 'right',
                distance: 0, // 向右偏移位置
                show: true
              }
            },
            data: datas,
            z: 0,
            animationEasing: 'elasticOut'
          },
          {
            name: '外框',
            type: 'bar',
            barGap: '-100%', // 设置外框粗细
            data: [
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total,
              total
            ],
            barWidth: 16,
            itemStyle: {
              normal: {
                color: 'transparent', // 填充色
                barBorderColor: '#06e3f1', // 边框色
                barBorderWidth: 1, // 边框宽度
                label: {
                  // 标签显示位置
                  show: false,
                  position: 'top' // insideTop 或者横向的 insideLeft
                }
              }
            },
            z: 0
          }
        ]
      }
      option && analysis.setOption(option)
    },
    getKyxm()
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 12, _exp: 'examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 2}
      window.post.getPost(paras1).then((ret) =>
      {
        this.kyxmData = []
        ret[0].data.forEach(item =>
        {
          this.kyxmData.push(item)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/DigitalScreen/LargeScreen.vue